import { List, Map } from "immutable";
import { get } from "../../../DeNieuweBibliotheek/custom_api/api";
import { objectMap } from "../../utils/object";
import { isNullOrWhitespace } from "../../utils/string";
import { media_image_parser } from "./parser";
const drupalUrl = "/api/drupal";
export const processRichText = (html)=>html.replace("<ul>", '<ul class="richtext__bullet-list">').replace("<ol>", '<ol class="richtext__check-list">');
// Replace internal with external Urls (to avoid users from being unable to see images served by the internal URL)
export const fixMediaUrl = (style_url)=>{
    if (isNullOrWhitespace(style_url)) return style_url;
    const internalUrl = window.DrupalInternalUrl;
    const externalUrl = window.DrupalExternalUrl;
    if (!externalUrl || !style_url) return style_url;
    if (style_url.startsWith('/')) return externalUrl + style_url;
    if (style_url && internalUrl) return style_url.replace(internalUrl, externalUrl);
    return style_url;
};
export const getImageStyles = async (imageIds)=>{
    var rawImageStyles = await get(`${drupalUrl}/api/image-styles/${imageIds.toSet().join('+')}`);
    if (rawImageStyles == 'error' || rawImageStyles == 'loading') return rawImageStyles;
    var parsedImageStyles = rawImageStyles.map(media_image_parser).map((media)=>{
        if (media.field_media_image.image == undefined) return media;
        const urls = media.field_media_image.image.style_urls;
        media.field_media_image.image.style_urls = objectMap(urls, (value, _)=>fixMediaUrl(value));
        return media;
    });
    return parsedImageStyles;
};
export const getDrupalActivities = async (pdbIds)=>{
    var activities = await get(`${drupalUrl}/api/activities/${pdbIds.join("+")}`);
    if (activities == 'error' || activities == 'loading') return activities;
    var imageIds = List(activities.map((a)=>parseInt(a.image_id)));
    var imageStyles = await getImageStyles(imageIds);
    if (imageStyles == 'error' || imageStyles == 'loading') return activities;
    // Create a map for faster lookup by mid
    const imageMap = Map(imageStyles.map((image)=>[
            image.id,
            image
        ]));
    const mappedActivities = activities.map((a)=>{
        a.image = imageMap.get(parseInt(a.image_id));
        return a;
    });
    return mappedActivities;
};
export const parseMetatagTitle = (metatag)=>{
    var _metatag_find_attributes, _metatag_find;
    return (_metatag_find = metatag.find((item)=>{
        var _item_attributes;
        return ((_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.name) === 'title';
    })) === null || _metatag_find === void 0 ? void 0 : (_metatag_find_attributes = _metatag_find.attributes) === null || _metatag_find_attributes === void 0 ? void 0 : _metatag_find_attributes.content;
};
export const parseFieldMetatags = (metatag, field, fallback)=>{
    if (!metatag) return fallback || '';
    const parsed = JSON.parse(metatag);
    return parsed[field] || fallback || '';
};
